import angularJwt from 'angular-jwt';

import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { AppSettingsModule } from 'services/settings.provider';
import { DataServiceModule } from './data.service';

export const HubspotServiceModule = angular
    .module('app.services.data.hubspotService', [
        angularJwt,
        AppSettingsModule,
        AuthTokenServiceModule,
        DataServiceModule
    ])
    .service('hubspotService', class HubspotService {
        constructor(
            $http,
            $log,
            $q,
            $timeout,
            $window,
            authTokenService,
            jwtHelper,
            settings,
            dataService) {
            'ngInject';

            angular.extend(this, {
                $http,
                $log,
                $q,
                $timeout,
                $window,
                authTokenService,
                jwtHelper,
                settings,
                dataService
            });
        }

        getTokenFromLocalStorage() {
            if (this.$window.localStorage.getItem('hubspotToken') !== null) {
                const tokenResponseJson = this.$window.localStorage.getItem('hubspotToken');
                return JSON.parse(tokenResponseJson);
            }
        }


        setTokenIntoLocalStorage(tokenResponse) {
            this.$window.localStorage.setItem('hubspotToken', JSON.stringify(tokenResponse));
        }

        removeTokenFromLocalStorage() {
            this.$window.localStorage.removeItem('hubspotToken');
        }

        isTokenValid(token) {
            const isExpired = this.jwtHelper.isTokenExpired(token);
            if (isExpired) {
                this.removeTokenFromLocalStorage();
                return this.$q.resolve(false);
            }
            return this.authTokenService.getEmail().then((email) => {
                const decoded = this.jwtHelper.decodeToken(token);
                if (decoded.sub !== email) {
                    this.removeTokenFromLocalStorage();
                    return false;
                }
                return true;
            });
        }

        createToken() {
            return this.dataService.create(this.settings.api.hubspotToken)
                .then((tokenResponse) => {
                    this.setTokenIntoLocalStorage(tokenResponse);
                    return tokenResponse;
                });
        }

        getToken() {
            const cachedTokenResponse = this.getTokenFromLocalStorage();
            if (cachedTokenResponse && cachedTokenResponse.token) {
                return this.isTokenValid(cachedTokenResponse.token).then((tokenIsValid) => {
                    if (tokenIsValid) {
                        return cachedTokenResponse;
                    }
                    return this.createToken();
                });
            }
            return this.createToken();
        }

        loadChatWidget() {
            return this.getToken().then((tokenResponse) => {
                if (this.$window.hsConversationsSettings) {
                    this.$window.hsConversationsSettings = {
                        identificationEmail: tokenResponse.email,
                        identificationToken: tokenResponse.token
                    };
                    if (this.$window.HubSpotConversations && this.$window.HubSpotConversations.widget) {
                        const status = this.$window.HubSpotConversations.widget.status();
                        if (status) {
                            if (status.loaded) {
                                this.$window.HubSpotConversations.widget.refresh();
                            } else {
                                this.$window.HubSpotConversations.widget.load();
                            }
                        }
                    }
                }
            }).catch((err) => {
                this.$log.error('Cannot identify visitor with Hubspot, error creating token:', err);
                if (this.$window.HubSpotConversations && this.$window.HubSpotConversations.widget) {
                    this.$window.HubSpotConversations.widget.remove();
                }
            });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/hubspot.service.js